import React from "react"

const BuildingDetails = (props) => {

    const property = props.property;

    const homeTypes = () =>{
        let home_types = property.home_type;
        if(home_types && home_types.length > 0){
            return(
                <>
                    <p><strong>Homes:</strong></p>
                    <ul>
                        {home_types &&
                            home_types.map((home_type) => {
                                return (
                                    <li key={home_type.name}>{home_type.name}</li>
                                )
                            })
                        }
                    </ul>
                </>

            )
        }
    }

    const coolingSystems = () =>{
        if(property.cooling_systems && property.cooling_systems.length > 0){
            return(
                <>
                    <p><strong>Cooling Systems:</strong></p>
                    <ul>
                        {property.cooling_systems &&
                            property.cooling_systems.map((cooling_system) => {
                                return (
                                    <li key={cooling_system}>{cooling_system}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const heatingSystems = () =>{
        if(property.heating_systems && property.heating_systems.length > 0){
            return(
                <>
                    <p><strong>Heating Systems:</strong></p>
                    <ul>
                        {property.heating_systems &&
                            property.heating_systems.map((heating_system) => {
                                return (
                                    <li key={heating_system}>{heating_system}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const typesOfOutbuildings = () =>{
        if(property.types_of_outbuildings && property.types_of_outbuildings.length > 0){
            return(
                <>
                    <p><strong>Types of Outbuildings:</strong></p>
                    <ul>
                        {property.types_of_outbuildings &&
                            property.types_of_outbuildings.map((outbuilding) => {
                                return (
                                    <li key={outbuilding.type}>{outbuilding.type}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const foundations = () =>{
        if(property.foundations && property.foundations.length > 0){
            return(
                <>
                    <p><strong>Foundations:</strong></p>
                    <ul>
                        {property.foundations &&
                            property.foundations.map((foundation) => {
                                return (
                                    <li key={foundation.foundation}>{foundation.foundation}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const waterfrontFeatures = () =>{
        if(property.waterfront_features && property.waterfront_features.length > 0){
            return(
                <>
                    <p><strong>Waterfront Features:</strong></p>
                    <ul>
                        {property.waterfront_features &&
                            property.waterfront_features.map((waterfront_feature) => {
                                return (
                                    <li key={waterfront_feature.feature}>{waterfront_feature.feature}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const exteriorFeatures = () =>{
        if(property.exterior_features && property.exterior_features.length > 0){
            return(
                <>
                    <p><strong>Exterior Features:</strong></p>
                    <ul>
                        {property.exterior_features &&
                            property.exterior_features.map((exterior_feature) => {
                                return (
                                    <li key={exterior_feature.feature}>{exterior_feature.feature}</li>
                                )
                            })
                        }
                    </ul>
                </>
            )
        }
    }

    const parkingTypesFeatures = () =>{
      if(property.parking_types && property.parking_types.length > 0){
        return(
          <>
            <p><strong>Parking Types:</strong></p>
            <ul>
              {property.parking_types &&
                property.parking_types.map((parking_type) => {
                  return (
                    <li key={parking_type}>{parking_type}</li>
                  )
                })
              }
            </ul>
          </>
        )
      }
    }


    return (
        <div>
            {property.number_of_homes &&
                <p><strong>Homes:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.number_of_homes}}></span></p>}

            {homeTypes()}

            {property.home_style &&
                <p><strong>Style of Home(s):</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.home_style}}></span></p>}

            {property.price_per_sq_foot &&
                <p><strong>Price per sq. ft.:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.price_per_sq_foot}}></span></p>}

            {property.finished_square_feet &&
                <p><strong>Finished Sq. Ft.:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.finished_square_feet}}></span></p>}

            {property.unfinished_square_feet &&
                <p><strong>Unfinished Sq. Ft.:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.unfinished_square_feet}}></span></p>}

            {property.bedrooms &&
                <p><strong>Bedrooms:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.bedrooms}}></span></p>}

            {property.bathrooms &&
                <p><strong>Full Bathrooms:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.bathrooms}}></span></p>}

            {property.quarter_bathrooms &&
                <p><strong>Quarter Bathrooms:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.quarter_bathrooms}}></span></p>}

            {property.half_bathrooms &&
                <p><strong>Half Bathrooms:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.half_bathrooms}}></span></p>}

            {property.three_quarter_bathroom &&
                <p><strong>Three-Quarter Bathrooms:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.three_quarter_bathroom}}></span></p>}

            {property.basement &&
                <p><strong>Basement:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.basement}}></span></p>}

            {parkingTypesFeatures()}

            {property.garage_spaces &&
                <p><strong>Total # of Spaces:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.garage_spaces}}></span></p>}

            {property.number_of_outbuildings &&
                <p><strong>Outbuildings:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.number_of_outbuildings}}></span></p>}

            {typesOfOutbuildings()}

            {property.other_types_of_improvements &&
                <p><strong>Other Improvements:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.other_types_of_improvements}}></span></p>}

            {property.fence_type &&
                <p><strong>Fence Type:</strong> <span className="no-style" dangerouslySetInnerHTML={{__html: property.fence_type}}></span></p>}

            {coolingSystems()}
            {heatingSystems()}
            {foundations()}
            {waterfrontFeatures()}
            {exteriorFeatures()}

        </div>
    )
  }

  export default BuildingDetails
